import { render, staticRenderFns } from "./CompetitionListMusicLayout.vue?vue&type=template&id=4f2347e4&scoped=true&"
import script from "./CompetitionListMusicLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListMusicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2347e4",
  null
  
)

export default component.exports